import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './features/auth'
import { CookieConsentBanner } from './features/auth'
import { Toaster } from 'react-hot-toast'
import useAnalytics from './hooks/useAnalytics'

// Pages
import LandingPage from './pages/LandingPage'
import Dashboard from './pages/Dashboard'
import VerificationSuccess from './pages/VerificationSuccess'
import PricingPage from './pages/PricingPage'

// Auth components
import { Auth, ForgotPasswordForm, ResetPassword } from './features/auth'

// Legal pages
import { PrivacyPolicy, TermsOfService, CookiePolicy, DPA } from './features/legal'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

const AnalyticsTracker = () => {
  useAnalytics()
  return null
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AnalyticsTracker />
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/forgot-password" element={<ForgotPasswordForm />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verification-success" element={<VerificationSuccess />} />
            <Route path="/verify-email" element={<VerificationSuccess />} />
            <Route path="/pricing" element={<PricingPage />} />
            
            {/* Legal pages */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/dpa" element={<DPA />} />
            
            {/* Protected routes */}
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
          </Routes>
          
          {/* Cookie Consent Banner */}
          <CookieConsentBanner />
          
          {/* Toast notifications */}
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#10B981',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#EF4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  )
}

export default App
